export default "__VITE_ASSET__DMUMgBpG__"